module.exports = __webpack_public_path__ + "img/avatar3.6c53bc61.png";